<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
     
        <el-breadcrumb-item  v-for="(item, index) in list" :key="index" :to="{path:item.path}">{{ item.name }}</el-breadcrumb-item>
     
    </el-breadcrumb>
  </div>
</template>
<style lang="scss">
</style>
<script>
export default {
  name: "Bread",
  components: {},
  props:{
    list: {
      type: Array,
      default() {
        return []
      }}

  },
  data() {
    return {};
  },
  created() {
    
  },
  mounted() {},
  // 其他页面进来时更新初始数据
  activated() {},
  methods: {},
};
</script>
